// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"632":"e5a4b204","636":"ff1d8bca","725":"1eabd5cc","787":"baaeb2a7","831":"139aeceb","968":"a653e0be","969":"58640659"}[chunkId] + ".chunk.js";
};